export * from './src/ecom-v1-pickup-location-pickup-locations.universal.js';
